/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valve_Add_New_BoxInputs */



/**
* | output |
* | --- |
* | "New thermostatic head" |
*
* @param {Valve_Add_New_BoxInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_add_new_box = /** @type {((inputs?: Valve_Add_New_BoxInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Add_New_BoxInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("New thermostatic head")
	return /** @type {LocalizedString} */ ("Nouvelle tête thermostatique")
});